import { useState } from 'react';

import { useDebounce } from './useDebounce.js';

interface UseDebouncedStateProps<T> {
  initialValue: T;
  debounceTimeMs?: number;
}

export function useDebouncedState<T>(props: UseDebouncedStateProps<T>) {
  const { initialValue, debounceTimeMs } = props;

  const [value, setValue] = useState<T>(initialValue);
  const debouncedValue = useDebounce<T>(value, debounceTimeMs);

  return {
    value,
    setValue,
    debouncedValue,
  };
}
